import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setSelectedSearchText } from "../../../store/userProfileOrganization";

export const OrganizationSelectedSearchBar = () => {
    const dispatch = useDispatch();
    const selectedSearchText = useSelector((state: RootState) => state.userProfileOrganization.selectedSearchText);

    return (
        <IonSearchbar
            value={selectedSearchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSelectedSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar en clientes seleccionados..."}
            autocomplete="off"
        />
    );
};